<template>
  <div>
    <ModalMailConfirm @hidden="completeStep" />
    <ModalMailConfirmReminder @hidden="completeStep" />
  </div>
</template>

<script>
import ModalMailConfirm from "@/components/notification/mail-confirm.vue";
import ModalMailConfirmReminder from "@/components/notification/mail-confirm-reminder.vue";

export default {
  name: "PipeEmailConfirm",
  components: {
    ModalMailConfirm,
    ModalMailConfirmReminder,
  },
  data() {
    return {
      completed: false,
    };
  },
  mounted() {
    console.log("--------- Pipeline Step MailConfirm ----------");
    this.$store.dispatch("user/increaseMailReminderCounter");

    if (this.$store.getters["user/showMailConfirmModal"]) {
      this.$bvModal.show("modal-mail-confirm");
    } else if (this.$store.getters["user/showMailConfirmReminderModal"]) {
      this.$bvModal.show("modal-mail-confirm-reminder");
    } else {
      this.completeStep();
    }
  },
  methods: {
    completeStep() {
      if (this.completed) {
        return;
      }

      this.completed = true;
      this.$store.commit("popups/setNextPipelineQueueStep");
    },
  },
};
</script>

<style scoped lang="scss"></style>
